import React from 'react';

import { imgLinks } from '../../shared';
import { useMenuIcon } from '../../hooks/useIcons';

import {
  StyledCompanyLogoWrapper,
  StyledHeader,
  StyledHeaderContainer,
  StyledHeaderSticky,
} from './Header.styled';

function HeaderWithoutActions() {
  const menuIcon = useMenuIcon();

  return (
    <StyledHeader>
      <StyledHeaderSticky data-header-menu>
        <StyledHeaderContainer>
          <StyledCompanyLogoWrapper to="/">
            <img src={imgLinks[menuIcon]} alt={menuIcon} />
          </StyledCompanyLogoWrapper>
        </StyledHeaderContainer>
      </StyledHeaderSticky>
    </StyledHeader>
  );
}

export default HeaderWithoutActions;
